var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('h1',{staticClass:"text-xs-center"},[_vm._v("SmartTransit Staff")]),_c('staff-management',{attrs:{"signed-in-user":_vm.signedInUser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }